import { getFipId } from "./fipResolver";

const FIP_CONFIG = [
  {
    key: "FINVU_BANK",
    id: getFipId("fip@finvubank-sit", "BARB0KIMXXX"),
    displayName: "Finvu Bank",
    category: "Banking",
  },
  {
    key: "DHANAGAR_BANK",
    id: getFipId("fip@dhanagarbank-sit", "dhanagarbank"),
    displayName: "Dhanagar Bank",
    category: "Banking",
  },
  {
    key: "FINSURE",
    id: getFipId("fip@finsure-sit", "fip@finsure"),
    displayName: "Finsure",
    category: "Insurance",
  },
  {
    key: "FINSURE_GENERAL",
    id: getFipId("fip@finsuregeneral-sit", "fip@finsuregeneral"),
    displayName: "Finsure General",
    category: "General_Insurance",
  },
  {
    key: "INSPOL",
    id: getFipId("fip@inspol-sit", "fip@inspol"),
    displayName: "FIP insurance policies",
    category: "InsurancePolicies",
  },
  {
    key: "GENERAL_INSURANCE",
    id: getFipId("fip@general-sit", "fip@general"),
    displayName: "General Insurance FIP",
    category: "GeneralInsurance",
  },
  {
    key: "LIFE_INSURANCE",
    id: getFipId("fip@life-sit", "fip@life"),
    displayName: "Life Insurance FIP",
    category: "LifeInsurance",
  },
  {
    key: "FINREPO",
    id: getFipId("fip@finrepo-sit", "fip@finrepo"),
    displayName: "Finrepo",
    category: "Eq&Mf",
  },
  {
    key: "GST",
    id: getFipId("fip@finvugst-sit", "fip@finvugst"),
    displayName: "Finvu GSTN",
    category: "Gst",
  },
  {
    key: "MFC",
    id: getFipId("fip@finmfc-sit", "fip@finmfc"),
    displayName: "MFC",
    category: "mfc",
  },
];

/**
 * Core resolver
 */
const resolveFip = (fipId) =>
  FIP_CONFIG.find((fip) => fip.id === fipId);

/**
 * Public helpers FIP_CONFIG
 */
export const getFipMeta = (fipId) => resolveFip(fipId) || {};

export const getFipDisplayName = (fipId) =>
  resolveFip(fipId)?.displayName || "";

export const getAccountCategoryFromFip = (fipId) =>
  resolveFip(fipId)?.category || "";

export const getFipIdByKey = (key) =>
  FIP_CONFIG.find((fip) => fip.key === key)?.id || "";


// Default FI type per category
const CATEGORY_FI_TYPE_MAP = {
  Banking: { fiType: "DEPOSIT", accountType: "SAVINGS" },

  Insurance: { fiType: "LIFE_INSURANCE", accountType: "DEFAULT" },
  InsurancePolicies: { fiType: "INSURANCE_POLICIES", accountType: "DEFAULT" },

  GeneralInsurance: { fiType: "GENERAL_INSURANCE", accountType: "DEFAULT" },
  General_Insurance: { fiType: "GENERAL_INSURANCE", accountType: "DEFAULT" },

  LifeInsurance: { fiType: "LIFE_INSURANCE", accountType: "DEFAULT" },

  "Eq&Mf": { fiType: "EQUITIES", accountType: "DEFAULT" },

  Gst: { fiType: "GSTR1_3B", accountType: "DEFAULT" },

  mfc: { fiType: "MFC_MF", accountType: "DEFAULT" },
};

export const getDefaultFiConfigFromFip = (fipId) => {
  const category = getAccountCategoryFromFip(fipId);
  return CATEGORY_FI_TYPE_MAP[category] || {
    fiType: "DEPOSIT",
    accountType: "SAVINGS",
  };
};
